import { useEffect } from 'react'

import { getPriceBaseOnCustomerType } from '@/open-web/utils/getPriceBaseOnCustomerType'
import type { CustomerType } from '@/shared/contentful/types'
import type { EnrichedContractTemplate } from '@/shared/services/campaignDataResolver'
import { logError } from '@/shared/utils/error'
import {
  getPriceElements,
  mapContractItemToGTM,
  useDeliveryInfo,
} from '@/shared/utils/gtm/gtmHelper'
import { contractItemsEvent } from '@/shared/utils/sendGTMEvent'

import { validateCustomerType } from '../../Price/utils'
import { useSelectedAddonsTariffNos } from '../../PriceBreakdown/hooks/useSelectedAddonsTariffNos'

export const useContractHeroAnalytics = ({
  contractTemplate,
}: {
  contractTemplate: EnrichedContractTemplate
}) => {
  const { error: contractError } = validateCustomerType(contractTemplate)

  if (contractError) {
    throw logError(contractError)
  }

  const customerType = contractTemplate.customerType.toLocaleLowerCase() as CustomerType

  const { deliveryArea, estimatedConsumption, deliveryStartDate } = useDeliveryInfo()

  const { selectedAddonsTariffNos } = useSelectedAddonsTariffNos({ contractTemplate })

  useEffect(
    () => {
      const priceElements = getPriceElements(
        contractTemplate,
        deliveryArea,
        estimatedConsumption,
        selectedAddonsTariffNos,
        deliveryStartDate,
      )
      const mappedContractItem = mapContractItemToGTM(contractTemplate, priceElements, null)

      contractItemsEvent(
        'view_item',
        {
          value: getPriceBaseOnCustomerType(
            priceElements.energyPriceElements?.estimatedMonthlyCostWithDiscounts,
            customerType,
          ),
          currency: contractTemplate.currency,
        },
        [mappedContractItem],
      )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [contractTemplate],
  )
}
